import React from "react";
import "./Training.css";
import trainingImg1 from "../../Images/trainingImg1.jpg";
import trainingImg2 from "../../Images/trainingImg2.webp";
import trainingImg3 from "../../Images/trainingImg3.png";
import trainingImg4 from "../../Images/trainingImg4.jpg";

const Training = () => {
  return (
    <div className="trainingSection">
      <div className="trainingHero">
        <img src={trainingImg1} alt="trainingImg1" />
        <div className="trainingHeroCover">
          <div className="trainingHeroText">
            <h1>Skill Up with Training That Leads to Real Opportunities</h1>
            <p>
              Discover training programs that build real-world skills for IT and
              non-IT careers. Learn with purpose, grow with confidence.
            </p>
          </div>
        </div>
      </div>
      <div className="trainingSection2" id="interview">
        <div className="section2text">
          <h2>Skill Up with Career-Focused Training</h2>
          <p>
            Empower your future with training programs designed for both
            individuals and organizations. Whether you're preparing for
            interviews or building long-term career skills, our modules cover
            everything from aptitude and soft skills to internships and
            certified courses. Learn with purpose, grow with confidence, and
            unlock real opportunities in IT, non-IT, and government sectors.
          </p>
        </div>
        <div className="section2Img">
          <img src={trainingImg2} alt="trainingImg2" />
        </div>
      </div>
      <h2>Individual Training</h2>
      <div className="trainingSection2">
        <div className="section2Img">
          <img src={trainingImg3} alt="trainingImg3" />
        </div>
        <div className="section2text">
          <h2>
            Focused preparation for interviews, aptitude tests, and career
            readiness.
          </h2>
          <p>
            Our Individual Training programs are tailored to help students and
            job seekers crack placement tests, ace interviews, and stay sharp on
            current affairs. With expert-led modules in Aptitude and Interview
            Preparation, we ensure you're confident, capable, and career-ready.
            Each session is designed to build not just skills but the mindset
            needed to thrive in competitive environments.
          </p>
        </div>
      </div>
      <div className="trainingCardsBlock">
        <div className="trainingCards">
          <h3>Aptitude Training</h3>
          <p>
            Master quantitative reasoning, logical thinking, and verbal ability
            with practice tests and expert strategies designed to boost speed
            and accuracy.
          </p>
        </div>
        <div className="trainingCards">
          <h3>Interview Preparation</h3>
          <p>
            Get ready to impress with mock interviews, HR and technical
            guidance, and curated content that builds clarity and confidence.
          </p>
        </div>
      </div>
      <a href="/individualTraining">
        <button>Read more</button>
      </a>
      <h2>Corporate Training</h2>
      <div className="trainingSection2">
        <div className="section2text">
          <h2>
            Industry-aligned programs for workforce development and career
            advancement.
          </h2>
          <p>
            Our Corporate Training offerings are designed to bridge the gap
            between academic learning and professional success. These programs
            include NSDC-certified internships, short-term skill-building
            modules, and intensive 6-month career courses tailored to meet the
            evolving demands of the job market. Learners gain hands-on
            experience, mentorship from industry experts, and exposure to
            real-world projects that enhance both technical and soft skills.
          </p>
        </div>
        <div className="section2Img">
          <img src={trainingImg4} alt="trainingImg3" />
        </div>
      </div>
      <div className="trainingCardsBlock">
        <div className="trainingCards">
          <h3>NSDC Internship</h3>
          <p>
            Gain hands-on experience with a government-recognized internship
            that builds foundational skills and boosts employability.
          </p>
        </div>
        <div className="trainingCards">
          <h3>Corporate Internship</h3>
          <p>
            Work on real-world projects, develop professional competencies, and
            receive mentorship from industry experts
          </p>
        </div>
        <div className="trainingCards">
          <h3>Career Course</h3>
          <p>
            A deep-dive training program that combines technical skills, soft
            skills, and placement support to launch your career with confidence.
          </p>
        </div>
      </div>
      <a href="/corporateTraining">
        <button>Read more</button>
      </a>
    </div>
  );
};

export default Training;
